import { useMutation } from '@tanstack/react-query';
import { CreateCustomerApiKey, UserAPI } from 'api/user';

export const useCreateCustomerApiKey = () => {
  return useMutation((p: CreateCustomerApiKey) =>
    UserAPI.createCustomerAPiKey(p),
  );
};
